// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lk-0";
export var buttonContainer = "_lk-3";
export var cancelButton = "_lk-4";
export var headerSection = "_lk-6";
export var headerTitle = "_lk-9";
export var messageSideLeft = "_lk-1";
export var messageSideRight = "_lk-2";
export var orderNumberContainer = "_lk-7";
export var orderNumberLabel = "_lk-8";
export var submitButton = "_lk-5";